import { render, staticRenderFns } from "./AgGridWrapper.vue?vue&type=template&id=49a37060"
import script from "./AgGridWrapper.vue?vue&type=script&lang=js"
export * from "./AgGridWrapper.vue?vue&type=script&lang=js"
import style0 from "./AgGridWrapper.vue?vue&type=style&index=0&id=49a37060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports